import { axiosInstance } from '../core/apiConfig';

export const ContractFlowClient = (): any => {
  function getQueryTest(testFlag: string) {
    return testFlag ? `?test=${testFlag}` : '';
  }

  async function saveUser(body: any, testFlag: string) {
    try {
      const queryTest = getQueryTest(testFlag);
      const res = await axiosInstance.post(
        `/v2/contract-flow/${queryTest}`,
        body
      );
      const data = res.data.data.result;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function getContractFlowInfo(uuid: any) {
    try {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const res = await axiosInstance.get(`/v2/contract-flow/${uuid}/`);
      const data = res.data.data.result;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function getContractFlowHtml(contractToken: string) {
    try {
      const res = await axiosInstance.get(
        `/users/contract-flows/${contractToken}/contracts/html`
      );
      const data = res.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function updateContractFlow(uuid: string, body: any, testFlag: string) {
    try {
      const queryTest = getQueryTest(testFlag);
      const res = await axiosInstance.patch(
        `/v2/contract-flow/${uuid}/${queryTest}`,
        body
      );
      const data = res.data.data.result;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function setPlaidManualVerification(body: any) {
    try {
      await axiosInstance.post(`/users/plaid-manually-verification/`, body);
      return [undefined, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function markBankAccountAsVierified(uuid: string) {
    try {
      await axiosInstance.patch(
        `/users/mark-bank-account-as-verified/${uuid}/`
      );

      return [undefined, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function subscribeWaitingList(body: any) {
    try {
      await axiosInstance.post(`/waitinglist`, body);

      return [undefined, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function calculateFee(uuid: any, months: any) {
    try {
      const res = await axiosInstance.get(`/v2/contract-flow/calculate-fee/`, {
        params: {
          uuid,
          months,
        },
      });
      const data = res.data.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function createPlaidLinkToken(cfUuid: any) {
    try {
      const res = await axiosInstance.post(`/users/plaid-link-token/`, {
        uuid: cfUuid,
      });

      const data = res.data.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  async function checkReferralCode(code: any, club_id = null) {
    try {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      let endpoint = `/referral-codes/${code}`;
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      if (club_id) endpoint = `${endpoint}/?club_id=${club_id}`;
      const res = await axiosInstance.get(endpoint);
      const { detail, shortDescription } = res.data;
      return [{ detail, shortDescription }, undefined];
    } catch (err: any) {
      // A request that never got a response (timeout, offline) has no `err.response`,
      // so only quote the server when it actually rejected the code.
      const status = err?.response?.status;
      const nonFieldError =
        err?.response?.data?.error?.errorList?.nonFieldErrors?.[0];
      const message =
        (status === 400 && nonFieldError) || 'Invalid referral code.';
      return [undefined, message];
    }
  }

  async function getOfferSimulation({
    dealValue,
    term,
    seats,
    referralCode,
  }: {
    dealValue: number | string;
    term: number | string;
    seats: number | string;
    referralCode?: string;
  }) {
    try {
      const res = await axiosInstance.get(`/v2/contract-flow/simulator/`, {
        params: {
          deal_value: dealValue,
          term,
          seats,
          ...(referralCode ? { referral_code: referralCode } : {}),
        },
      });
      return [res.data.data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  async function continueContract(email: string) {
    try {
      const res = await axiosInstance.post(`/mailing/continue-contract`, {
        email,
      });

      const data = res.data.data;
      return [data, undefined];
    } catch (error) {
      return [undefined, error];
    }
  }

  return {
    saveUser,
    getContractFlowInfo,
    getContractFlowHtml,
    updateContractFlow,
    calculateFee,
    subscribeWaitingList,
    setPlaidManualVerification,
    markBankAccountAsVierified,
    createPlaidLinkToken,
    checkReferralCode,
    getOfferSimulation,
    continueContract,
  };
};
